export const htmlContent = `
<!-- saved from url=(0014)about:internet -->
<html><head><meta http-equiv="Content-Type" content="text/html; charset=windows-1252">

<meta name="DROPS" content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:David;}
@font-face
	{font-family:MeteorMF;}
@font-face
	{font-family:MetaBook-Roman;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:3.0pt;
	margin-left:0in;
	text-align:justify;
	line-height:150%;
	direction:rtl;
	unicode-bidi:embed;
	font-size:11.0pt;
	font-family:"Times New Roman",serif;}
p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
	{margin-top:0in;
	margin-right:.5in;
	margin-bottom:3.0pt;
	margin-left:0in;
	text-align:justify;
	line-height:150%;
	direction:rtl;
	unicode-bidi:embed;
	font-size:11.0pt;
	font-family:"Times New Roman",serif;}
p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst
	{margin-top:0in;
	margin-right:.5in;
	margin-bottom:0in;
	margin-left:0in;
	text-align:justify;
	line-height:150%;
	direction:rtl;
	unicode-bidi:embed;
	font-size:11.0pt;
	font-family:"Times New Roman",serif;}
p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle
	{margin-top:0in;
	margin-right:.5in;
	margin-bottom:0in;
	margin-left:0in;
	text-align:justify;
	line-height:150%;
	direction:rtl;
	unicode-bidi:embed;
	font-size:11.0pt;
	font-family:"Times New Roman",serif;}
p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast
	{margin-top:0in;
	margin-right:.5in;
	margin-bottom:3.0pt;
	margin-left:0in;
	text-align:justify;
	line-height:150%;
	direction:rtl;
	unicode-bidi:embed;
	font-size:11.0pt;
	font-family:"Times New Roman",serif;}
.MsoChpDefault
	{font-size:10.0pt;}
 /* Page Definitions */
 @page WordSection1
	{size:595.3pt 841.9pt;
	margin:70.9pt 70.9pt 70.9pt 70.9pt;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>

</head>

<body lang="EN-US" style="word-wrap:break-word">

<div class="WordSection1" dir="RTL">

<p class="MsoNormal" align="center" dir="LTR" style="text-align:center;line-height:
normal;direction:ltr;unicode-bidi:embed"><b><span style="font-size:12.0pt">[DROPS]
– Terms of Use</span></b></p>

<p class="MsoNormal" dir="LTR" style="text-align:justify;line-height:normal;
direction:ltr;unicode-bidi:embed"><span style="font-size:12.0pt">&nbsp;</span></p>

<p class="MsoNormal" dir="LTR" style="text-align:justify;line-height:normal;
direction:ltr;unicode-bidi:embed"><span style="font-size:12.0pt">These Terms of
Use (the “<b>Terms</b>”) apply to and govern the access and use of the [DROPS] (the
“<b>Tool</b>”) which is provided by SYGNIA Consulting Ltd. (the “<b>Company</b>”)
through its website (the “<b>Website</b>”). These Terms constitute an agreement
(the “<b>Agreement</b>”) between the Company and you (the “<b>User</b>” or “<b>you</b>”).
The Company reserves the right, at its sole discretion, to modify these Terms
at any time by posting the modified provisions on its Website, and User shall
be responsible for reviewing and becoming familiar with any such modifications.
Please note that any such modifications shall become effective immediately upon
posting. These Terms are subject to the general Terms of Use of the Company’s
Website. IF YOU DO NOT AGREE TO ALL OF THESE TERMS AND CONDITIONS, YOU SHOULD
NOT ACCESS OR USE THE TOOL. </span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">THE TOOL </span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">1.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool supplies a dynamic,
web-based, operation aid for the usage of publicly available open source
security tools made and used by the cyber security industry (the “<b>Public
Tools</b>”). It contains, by reference to the Public Tools and the relevant MITRE
TTP, a curated list of public security tools and their respective commands for various
environments. </span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">1.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool allows Users who already
obtained and installed the Public Tools, to generate operation commands for the
User to input into the Public Tools by a simple copy-paste operation, all based
on the publicly available documentation of the Public Tools. For avoidance of
doubt, the Company did not create and does not provide any of the Public Tools and
does not operate them for or on behalf of the User.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">1.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool does not collect and/or
process any information on Users. The Tool may collect non-identifiable information
for analytic purposes, such as information as to the Tool’s usage, Public Tools
and/or commands which are mostly used, etc. </span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">USAGE RULES </span></p>

<p class="MsoListParagraphCxSpMiddle" dir="LTR" style="margin-top:0in;margin-right:
0in;margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">2.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool may be used only for
legitimate, lawful, non-offensive purposes, such as legitimate, fully
authorized security assessments, training and for the development of defensive
security tools.</span></p>

<p class="MsoListParagraphCxSpMiddle" dir="LTR" style="margin-top:0in;margin-right:
0in;margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">2.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool may only be used in
non-embargoed countries and by persons or entities who are not sanctioned under
any sanction list; and</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">2.3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Tool may only be used in full
compliance with applicable laws, including but not limited to all applicable privacy,
information security, computer, export control and cyber security laws and
regulations.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><a name="_Ref102040226"><span style="font-size:12.0pt">3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="LTR"></span><span style="font-size:12.0pt">WARRANTY
DISCLAIMER</span></a></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">3.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">User acknowledges and agrees that
use of the Tool is at his/her own responsibility and risk. The Company hereby
disclaims any and all express or implied warranties, including without
limitation warranties of functionality, availability, fitness for a particular
or any purpose, performance, satisfactory quality, accuracy, reliability, and
non-infringement. User acknowledges that the Company does not warrant that the Tool,
or any of the Public Tools used or interfaced with, will be uninterrupted,
secure, free of harmful components or error-free. Except as expressly provided
for in these Terms, to the extent permitted by law, the Company excludes all
warranties, guarantees, conditions, representations, and undertakings.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">3.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">The Company may discontinue
providing the Tool or may change the nature features, functions, scope or operation
thereof, at any time and from time to time. To extent permitted by applicable
law, the Company or any of its affiliates do not warrant that the Tool will
continue to be provided, will function as described, consistently or in any
particular manner.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">LIMITATION OF LIABILITY</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">4.1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">Under no circumstances and under
no legal theory, including, but not limited to, tort, contract, negligence,
strict liability, or otherwise, shall the Company or its affiliates be liable
to User, its affiliates or any other person or entity for any direct or
indirect, special, incidental, or consequential damages including, without
limitation, any loss of use or downtime,&nbsp; damages for lost profits, savings or
revenues, loss of goodwill, loss of or corruption to data, or damages resulting
from User’s use or misuse of the Tool, including any damage relating to the
procurement by the User of any substitute services. The foregoing limitations
shall apply even if the Company has been informed of the possibility of such
damages.</span></p>

<p class="MsoListParagraphCxSpMiddle" dir="LTR" style="margin-top:0in;margin-right:
0in;margin-bottom:3.0pt;margin-left:.55in;text-align:justify;text-indent:-.3in;
line-height:normal;direction:ltr;unicode-bidi:embed"><span style="font-size:
12.0pt">4.2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span><span dir="LTR"></span><span style="font-size:12.0pt">In any event, to the maximum
extent permitted by applicable law, the total and aggregate liability of the
Company, its affiliates and its and their employees, directors, officers,
shareholders, advisors, and anyone acting on the Company’s or their behalf, for
any and all damages to the User and any of its affiliates arising out of or
related to the access or usage of the Tool and/or these Terms, shall be limited
to and shall not exceed the total amount of one hundred (100) US dollars.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><a name="_Ref102040251"><span style="font-size:12.0pt">5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="LTR"></span><span style="font-size:12.0pt">INDEMNIFICATION</span></a></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;line-height:normal;
direction:ltr;unicode-bidi:embed"><span style="font-size:12.0pt">Upon its first
demand, User will defend, indemnify and hold the Company, its affiliates, and
each of their shareholders, directors, officers, employees, agents and
representatives harmless from and against any claim, suits, liability, cost,
loss, penalties, fines, damage and expense (including reasonable legal fees)
arising from and/or caused due to: (a) User’s use, misuse of, and/or activities
in connection with the Tool; (b) User’s violation of these Terms or any portion
thereof (c) User’s actual or alleged infringement, misappropriation or
violation of the Company’s, its affiliates’ or any third party’s rights,
including without limitation privacy right, copyright or any other intellectual
property or proprietary rights of a third party; and (d) any damage of any sort,
whether direct, indirect, special or consequential, User may cause to any third
party with relation to User’s use of the Tool. Without derogating from the
foregoing, the Company reserves the right, at its expense, to assume the
exclusive defense and control of any matter which is subject to indemnification
by User, which will not excuse User’s indemnity obligations herein and in which
event User will fully cooperate with the Company in asserting any available
defense. User agrees not to settle any matter subject to an indemnification by
User without first obtaining the Company’s prior express written approval.</span></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:8.0pt;margin-right:0in;
margin-bottom:3.0pt;margin-left:17.85pt;text-align:justify;text-indent:-17.85pt;
line-height:normal;direction:ltr;unicode-bidi:embed"><a name="_Ref102040266"><span style="font-size:12.0pt">6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="LTR"></span><span style="font-size:12.0pt">GOVERNING LAW</span></a></p>

<p class="MsoListParagraph" dir="LTR" style="margin-top:0in;margin-right:0in;
margin-bottom:3.0pt;margin-left:.55in;text-align:justify;line-height:normal;
direction:ltr;unicode-bidi:embed"><span style="font-size:12.0pt">This Agreement
shall be exclusively governed by and construed in accordance with the laws of
the State of Israel, without giving effect to the rules respecting
conflict-of-law. The competent courts located in the city of Tel-Aviv-Yaffo
shall have exclusive jurisdiction over any dispute arising in connection with
the Tool or these Terms.</span></p>

</div>




</body></html>
`

// export default htmlContent;